export const FIREBASE_ERROR_MESSAGES: Record<string, string> = {
  'auth/invalid-credential': 'Invalid email or password',
  'auth/user-not-found': 'No account found with this email',
  'auth/wrong-password': 'Incorrect password',
  'auth/too-many-requests': 'Too many attempts. Try again later',
  'auth/popup-closed-by-user': 'Sign-in popup was closed',
  'auth/email-already-in-use': 'An account with this email already exists',
  'auth/weak-password': 'Password should be at least 6 characters',
  'auth/invalid-action-code': 'This invite link has already been used or has expired',
  'auth/expired-action-code': 'This invite link has already been used or has expired',
};

export function getFirebaseMessage(code: string): string {
  return FIREBASE_ERROR_MESSAGES[code] ?? 'Authentication failed. Try again';
}
